import React, { Component } from "react";
import { HelpBlock, Modal, FormGroup, FormControl } from "react-bootstrap";

import Validator from "../../../Components/FormComponent/Validator";
import FormComponent from "../../../Components/FormComponent/FormComponent";
import Loader from "dataphi-react-components/dist/Containers/DataphiLoader/Component/LoaderComponent";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ReactTooltip from "react-tooltip";

import Constants from "../../../Phi/Constants";

import Header from "./Components/Header";
import Footer from "./Components/Footer";
import DataPolicy from "./Components/DataPolicy";
import MagicLinkWarning from "./Components/MagicLinkWarning";
// import InvitationRequest from "./Components/InvitationRequest";
import InvitationRequest from "../../InvitationRequestContainer";

import DialogForgotPassword from "../../DialogForgotPasswordContainer";

import Source from "../source";

import "./Auth.css";

import hsgMainIllustration from "./Assets/hsg-main-illustration.png";

class Auth extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModalDataPolicy: false,
      showModalForgotAccount: false,
      showModalErrorMagicLink: false,
      showModalMagicLink: false,
      showModalInvitationRequest: false,
      showUnauthorisedModal:false,
      currentActiveForm: Source.FORM_TYPE.login,
    };
  }

  componentWillMount() {
    if (
      this.props.location.search &&
      this.props.location.search.match("data-policy")
    ) {
      this.setState({ showModalDataPolicy: true });
    }
    if (this.props.showInvitationLinkModal) {
      this.setState({
        showModalInvitationRequest: this.props.showInvitationLinkModal,
        showModalInvalidInvitationRequest: !this.props.isInvitationLinkSuccess,
      });
    }
  }

  componentDidUpdate(oldProps, oldState) {}

  componentWillReceiveProps(newProps) {
    if (
      newProps.loginError &&
      newProps.loginMessage &&
      newProps.loginErrorCode == 401
    ) {
      let possibleResponse = {
        ErrorPassword: () =>
          this.setState({
            loginFormErrorPassword:
              Source.STRING_LOGIN_FORM_RESPONSE_INCORRECT_PASSWORD,
          }),
        ErrorUsername: () =>
          this.setState({
            loginFormErrorUserName:
              Source.STRING_LOGIN_FORM_RESPONSE_INCORRECT_USERNAME,
          }),
      };
      try {
        possibleResponse[newProps.loginMessage]();
      } catch (e) {
        console.log("Unwanted Login Response");
      }
    }

    if (newProps.emailVerified && !newProps.emailAvailable) {
      this.setState({
        signUpFormErrorEmailAddress:
          Source.STRING_SIGN_UP_FORM_RESPONSE_EMAIL_TAKEN,
      });
    }

    if (newProps.phoneVerified && !newProps.phoneAvailable) {
      this.setState({
        signUpFormErrorPhoneNumber:
          Source.STRING_SIGN_UP_FORM_RESPONSE_PHONE_TAKEN,
      });
    }

    if (
      newProps.isMagicLinkUsed &&
      !newProps.isMagicLinkSuccess &&
      !this.state.showModalErrorMagicLink
    ) {
      newProps.changeMagicLinkStatus(false);
      this.setState({
        showModalMagicLink: true,
        showModalErrorMagicLink: true,
      });
    }

    if(this.props.loginMessage === 'Invalid User'){
      this.setState({
        showUnauthorisedModal: true,
      });
    }
    // if (
    //     newProps.isInvitationLinkUsed &&
    //     (newProps.isInvitationLinkSuccess !== this.props.isInvitationLinkSuccess || newProps.isInvitationLinkFailed !== this.props.isInvitationLinkFailed)
    // ) {
    //     this.setState({ showModalInvitationRequest: true, showModalInvalidInvitationRequest: !newProps.isInvitationLinkSuccess });
    // }
    if (
      newProps.showInvitationLinkModal !== this.props.showInvitationLinkModal
    ) {
      this.setState({
        showModalInvitationRequest: newProps.showInvitationLinkModal,
        showModalInvalidInvitationRequest: !newProps.isInvitationLinkSuccess,
      });
    }
  }

  authContentLoginFormValidations = (key, value) => {
    const possibleMap = {
      loginFormUserName: (value) =>
        Validator.requiredWithCustomMessage(
          value,
          Source.STRING_ERROR_EMPTY_FIELD_MESSAGE("Username")
        ) ||
        (!Validator.indianPhoneValidator(value)
          ? undefined
          : !Validator.checkEmail(value)
          ? undefined
          : Source.STRING_ERROR_USERNAME),
      loginFormPassword: (value) =>
        Validator.requiredWithCustomMessage(
          value,
          Source.STRING_ERROR_EMPTY_FIELD_MESSAGE("Password")
        ),
    };

    return possibleMap[key](value);
  };

  authContentLoginFormInputField = (
    key,
    type,
    label,
    placeholder,
    value,
    onChange,
    error
  ) => (
    <div>
      <div className="hsg-auth-content-login-form-group col-xs-12">
        <label className="hsg-auth-content-login-form-label" htmlFor={key}>
          {label}
        </label>
        {error ? (
          <i
            className="fa fa-info-circle hsg-auth-content-login-form-error-icon"
            aria-hidden="true"
          />
        ) : null}
        <input
          name={key}
          data-tip=""
          data-for={`${key}-tooltip`}
          className={`hsg-auth-content-login-form-input ${
            error ? "hsg-auth-content-login-form-input-error" : ""
          }`}
          id={key}
          placeholder={placeholder}
          type={type}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
        />
        {/* <span class="hsg-auth-content-login-form-error">{}</span> */}
      </div>
      <ReactTooltip id={`${key}-tooltip`} type="error" effect="solid">
        {error}
      </ReactTooltip>
    </div>
  );

  authContentLoginFormDefs = () => (
    <div>
      {Source.FORM_LOGIN.map((element, index) => (
        <div key={index}>
          {this.authContentLoginFormInputField(
            element.key,
            element.type,
            element.label,
            element.placeholder,
            this.state[element.meta.value],
            (e) =>
              this.setState({
                [element.meta.value]: e,
                [element.meta.error]: this.authContentLoginFormValidations(
                  element.meta.value,
                  e
                ),
              }),
            this.state[element.meta.error]
          )}
        </div>
      ))}
    </div>
  );

  authContentLoginFormForgotPassword = () => (
    <div>
      <div className="col-xs-12">
        <div
          className="hsg-auth-content-login-form-forgot-password"
          onClick={() =>
            this.setState({
              showModalForgotAccount: true,
              typeModalForgotAccount: Source.TYPE_MODAL.otp,
            })
          }
        >
          {Source.STRING_LOGIN_FORM_FORGOT_PASSWORD}
        </div>
      </div>
    </div>
  );

  validateLoginFormSubmission = () => {
    const {
      loginFormUserName,
      loginFormPassword,
      loginFormErrorUserName,
      loginFormErrorPassword,
    } = this.state;

    if (
      loginFormUserName &&
      loginFormPassword &&
      !loginFormErrorUserName &&
      !loginFormErrorPassword
    ) {
      return true;
    }

    return false;
  };

  authContentLoginSubmissionDefaultErrors = () => {
    Source.FORM_LOGIN.forEach((element) => {
      if (!this.state[element.meta.error]) {
        this.setState({
          [element.meta.error]: this.authContentLoginFormValidations(
            element.meta.value,
            this.state[element.meta.value]
          ),
        });
      }
    });
  };

  authContentLoginSubmissionHandle = (e) => {
    e.preventDefault();

    let status = this.validateLoginFormSubmission();
    if (status) {
      this.props.loginUser({
        username: this.state.loginFormUserName,
        password: this.state.loginFormPassword
      });
    } else {
      this.authContentLoginSubmissionDefaultErrors();
    }
  };

  authContentLoginFormSubmission = () => (
    <div>
      <div className="center">
        <button
          type="submit"
          className="hsg-btn hsg-auth-content-login-form-submission"
          onClick={(e) => this.authContentLoginSubmissionHandle(e)}
        >
          {Source.STRING_LOGIN_FORM_SUBMISSION}
        </button>
      </div>
    </div>
  );

  authContentLoginFormOtherOptions = () => (
    <div>
      <div className="center">
        <div className="hsg-auth-content-login-form-other-options">
          {Source.STRING_LOGIN_FORM_OTHER_OPTIONS["0"]}{" "}
          <span
            className="hsg-auth-content-login-form-other-options-clickable"
            onClick={() =>
              this.setState({
                showModalForgotAccount: true,
                typeModalForgotAccount: Source.TYPE_MODAL.magicLink,
              })
            }
          >
            {Source.STRING_LOGIN_FORM_OTHER_OPTIONS["1"]}
          </span>{" "}
          {/* {Source.STRING_LOGIN_FORM_OTHER_OPTIONS['2']} {" "}
                    <span className="hsg-auth-content-login-form-other-options-clickable">{Source.STRING_LOGIN_FORM_OTHER_OPTIONS['3']}</span> */}
        </div>
      </div>
    </div>
  );

  authContentLoginFormSignUpSwitch = () => (
    <div>
      <div className="center">
        <div className="hsg-auth-content-login-form-sign-up-switch">
          {Source.STRING_LOGIN_FORM_SIGNUP_SWITCH["0"]}{" "}
          <span
            className="hsg-auth-content-login-form-sign-up-switch-clickable"
            onClick={() =>
              this.setState({ currentActiveForm: Source.FORM_TYPE.signup })
            }
          >
            {Source.STRING_LOGIN_FORM_SIGNUP_SWITCH["1"]}
          </span>{" "}
        </div>
      </div>
    </div>
  );

  authContentLoginForm = () => (
    <form onSubmit={(e) => this.authContentLoginSubmissionHandle(e)}>
      <div className="col-xs-12 center">
        <div className="row hsg-auth-content-login-form-head">
          {Source.STRING_LOGIN_FORM_HEAD}
        </div>
        <div className="row hsg-auth-content-login-form">
          {this.authContentLoginFormDefs()}
          {this.authContentLoginFormForgotPassword()}
          {this.authContentLoginFormSubmission()}
          {/* {this.authContentLoginFormOtherOptions()} */}
          {this.authContentLoginFormSignUpSwitch()}
        </div>
      </div>
    </form>
  );

  authContentSignUpFormInputField = (
    index,
    classGroup,
    key,
    type,
    label,
    placeholder,
    value,
    onChange,
    error
  ) => (
    <div key={index}>
      <div className={classGroup}>
        <label className="hsg-auth-content-sign-up-form-label" for={key}>
          {label}
        </label>
        {this.state[error] ? (
          <i
            className="fa fa-info-circle hsg-auth-content-sign-up-form-error-icon"
            aria-hidden="true"
          />
        ) : null}
        <input
          name={key}
          className={`hsg-auth-content-sign-up-form-input ${
            this.state[error] ? "hsg-auth-content-sign-up-form-input-error" : ""
          }`}
          data-tip=""
          data-for={`${key}-tooltip`}
          id={key}
          placeholder={placeholder}
          type={type}
          value={this.state[value] || ""}
          autoComplete="disabled"
          onChange={(e) => onChange(e.target.value, value, error)}
        />
        {/* <span class="hsg-auth-content-sign-up-form-error col-xs-12 padding-0">{this.state[error]}</span> */}
      </div>
      <ReactTooltip
        className="hsg-auth-content-sign-up-form-error-tooltip"
        id={`${key}-tooltip`}
        type="error"
        effect="solid"
      >
        {this.state[error]}
      </ReactTooltip>
    </div>
  );

  authContentSignUpFormValidations = (key, value) => {
    let possibleMap = {
      signUpFormFirstName: (value) =>
        Validator.requiredWithCustomMessage(
          value,
          Source.STRING_ERROR_EMPTY_FIELD_MESSAGE("First Name")
        ) || Validator.checkPersonName(value),
      signUpFormLastName: (value) =>
        Validator.requiredWithCustomMessage(
          value,
          Source.STRING_ERROR_EMPTY_FIELD_MESSAGE("Last Name")
        ) || Validator.checkPersonName(value),
      signUpFormEmailAddress: (value) =>
        Validator.requiredWithCustomMessage(
          value,
          Source.STRING_ERROR_EMPTY_FIELD_MESSAGE("Email Address")
        ) || Validator.checkEmail(value),
      signUpFormPhoneNumber: (value) =>
        Validator.requiredWithCustomMessage(
          value,
          Source.STRING_ERROR_EMPTY_FIELD_MESSAGE("Mobile Number")
        ) || Validator.indianPhoneValidator(value),
      signUpFormCreatePassword: (value) =>
        Validator.requiredWithCustomMessage(
          value,
          Source.STRING_ERROR_EMPTY_FIELD_MESSAGE("Password")
        ) ||
        Validator.minValue(
          4,
          "Password should be 4 character or more"
        )((value && value.length) || 0),
    };

    return possibleMap[key](value);
  };

  authContentSignUpFormAddName = (value, key, error) =>
    this.setState({
      [key]: value,
      [error]: this.authContentSignUpFormValidations(key, value),
    });

  authContentSignUpFormAddEmail = (value, key, error) => {
    let possibleError = this.authContentSignUpFormValidations(key, value);

    this.setState({
      [key]: value,
      [error]: possibleError,
    });

    if (value && !possibleError) {
      this.props.checkEmailAvailability(value);
      this.props.changeValidationResponseType("");
    }
  };

  authContentSignUpFormAddPhone = (value, key, error) => {
    let possibleError = this.authContentSignUpFormValidations(key, value);

    this.setState({
      [key]: value,
      [error]: possibleError,
    });

    if (value && !possibleError) {
      this.props.checkPhoneNumberAvailability(value);
      this.props.changeValidationResponseType("");
    }
  };

  authContentSignUpFormAddPassword = (value, key, error) =>
    this.setState({
      [key]: value,
      [error]: this.authContentSignUpFormValidations(key, value),
    });

  authContentSignUpFormDefs = () => {
    let changeFunctions = {
      //First Name
      [Source.FORM_SIGN_UP[0].key]: (value, key, error) =>
        this.authContentSignUpFormAddName(value, key, error),
      //Last Name
      [Source.FORM_SIGN_UP[1].key]: (value, key, error) =>
        this.authContentSignUpFormAddName(value, key, error),
      //Email
      [Source.FORM_SIGN_UP[2].key]: (value, key, error) =>
        this.authContentSignUpFormAddEmail(value, key, error),
      //Phone
      [Source.FORM_SIGN_UP[3].key]: (value, key, error) =>
        this.authContentSignUpFormAddPhone(value, key, error),
      //Password
      [Source.FORM_SIGN_UP[4].key]: (value, key, error) =>
        this.authContentSignUpFormAddPassword(value, key, error),
    };

    return Source.FORM_SIGN_UP.map((element, index) => {
      return this.authContentSignUpFormInputField(
        index,
        element.groupClass,
        element.key,
        element.type,
        element.label,
        element.placeholder,
        element.meta.value,
        changeFunctions[element.key],
        element.meta.error
      );
    });
  };

  authContentSignUpDataPolicy = () => (
    <div>
      <div className="center col-xs-12">
        <div className="hsg-auth-content-sign-up-form-data-policy">
          {Source.STRING_SIGN_UP_FORM_DATA_POLICY[0]}{" "}
          <span
            className="hsg-auth-content-sign-up-form-data-policy-clickable"
            onClick={() => this.setState({ showModalDataPolicy: true })}
          >
            {Source.STRING_SIGN_UP_FORM_DATA_POLICY[1]}
          </span>
        </div>
      </div>
    </div>
  );

  validateSignUpFormSubmission = () => {
    let formMap = {
      signUpFormFirstName: "firstName",
      signUpFormLastName: "lastName",
      signUpFormEmailAddress: "email",
      signUpFormPhoneNumber: "phone",
      signUpFormCreatePassword: "password",
    };

    let status = true;
    let form = {};

    for (let i = 0; i < Source.FORM_SIGN_UP.length; i++) {
      let element = Source.FORM_SIGN_UP[i];
      if (!this.state[element.meta.value] || !!this.state[element.meta.error]) {
        status = false;
        break;
      } else {
        form = {
          ...form,
          [formMap[element.meta.value]]: this.state[element.meta.value],
        };
      }
    }

    return { status, form };
  };

  authContentSignUpSubmissionDefaultErrors = () => {
    Source.FORM_SIGN_UP.forEach((element) => {
      if (!this.state[element.meta.error]) {
        this.setState({
          [element.meta.error]: this.authContentSignUpFormValidations(
            element.meta.value,
            this.state[element.meta.value]
          ),
        });
      }
    });
  };

  authContentSignUpSubmissionHandle = (e) => {
    e.preventDefault();
    const { status, form } = this.validateSignUpFormSubmission();
    // form.password = encryptPassword(form.password, form.password.length);

    if (status) {
      this.props.signupUserV2(form);
    } else {
      this.authContentSignUpSubmissionDefaultErrors();
    }
  };

  authContentSignUpSubmission = () => (
    <div>
      <div className="center">
        <button
          type="submit"
          className="hsg-btn hsg-auth-content-sign-up-form-submission"
          onClick={(e) => this.authContentSignUpSubmissionHandle(e)}
        >
          {Source.STRING_SIGN_UP_FORM_SUBMISSION}
        </button>
      </div>
    </div>
  );

  authContentSignUpFormLoginSwitch = () => (
    <div>
      <div className="center">
        <div
          className="hsg-auth-content-sign-up-form-login-switch"
          onClick={() =>
            this.setState({ currentActiveForm: Source.FORM_TYPE.login })
          }
        >
          {Source.STRING_SIGN_UP_FORM_LOGIN_SWITCH}
        </div>
      </div>
    </div>
  );

  authContentSignUpForm = () => (
    <form onSubmit={(e) => this.authContentSignUpSubmissionHandle(e)}>
      <div className="col-xs-12 center">
        <div className="row hsg-auth-content-sign-up-form-head">
          {Source.STRING_SIGN_UP_FORM_HEAD}
        </div>
        <div className="row hsg-auth-content-sign-up-form-sub-head">
          {Source.STRING_SIGN_UP_FORM_SUB_HEAD}
        </div>
        <div className="row hsg-auth-content-sign-up-form">
          {this.authContentSignUpFormDefs()}
          {this.authContentSignUpDataPolicy()}
          {this.authContentSignUpSubmission()}
          {this.authContentSignUpFormLoginSwitch()}
        </div>
      </div>
    </form>
  );

  authContent = () => (
    <div className="container-fluid">
      <div className="col-sm-6 hidden-xs">
        <div className="hsg-auth-content-root">
          <img
            className="hsg-auth-mail-illustration"
            src={hsgMainIllustration}
          ></img>
        </div>
      </div>
      <div className="col-sm-6 col-xs-12">
        {this.state.currentActiveForm === Source.FORM_TYPE.login ? (
          <div className="hsg-auth-content-root">
            {this.authContentLoginForm()}
          </div>
        ) : (
          <div className="hsg-auth-content-root">
            {this.authContentSignUpForm()}
          </div>
        )}
      </div>
    </div>
  );

  modalForgotAccount = () => (
    <DialogForgotPassword
      show={this.state.showModalForgotAccount}
      onClose={() => this.setState({ showModalForgotAccount: false })}
      onHide={() => this.setState({ showModalForgotAccount: false })}
    />
  );

  render() {
    const {} = this.state;

    return (
      <div className="hsg-auth-main-root">
        <Header />
        {this.authContent()}

        {this.modalForgotAccount()}
        <Loader blockUI={true} isLoading={this.props.isLoading} />
        <DataPolicy
          show={this.state.showModalDataPolicy}
          onClose={() => this.setState({ showModalDataPolicy: false })}
        />
        <MagicLinkWarning
          modalFor = "magiclink"
          show={this.state.showModalMagicLink}
          onClose={() => this.setState({ showModalMagicLink: false })}
          onForgotPassword={() =>
            this.setState({
              showModalForgotAccount: true,
              typeModalForgotAccount: Source.TYPE_MODAL.magicLink,
            })
          }
        />
        {this.props.loginMessage === 'Invalid User' && this.state.showUnauthorisedModal && <MagicLinkWarning
          modalFor = "unauthorised"
          show={this.state.showUnauthorisedModal}
          onClose={() => {this.setState({ showUnauthorisedModal: false }); this.props.resetLoginResponse()}}
        />}
        <InvitationRequest
          show={this.state.showModalInvitationRequest}
          isInvalidRequest={this.state.showModalInvalidInvitationRequest}
          onClose={() => this.setState({ showModalInvitationRequest: false })}
        />
        <ToastContainer />

        {/* <Footer /> */}
      </div>
    );
  }
}

export default Auth;
